import { Injectable, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export enum TokenType {
  JWT = 'jwt',
  ACCESS = 'access'
}

@Injectable({ providedIn: 'root' })
export class HttpHeadersService {
  private readonly oidc = inject(OidcSecurityService);

  async getBaseHeaders(tokenType?: TokenType): Promise<Record<string, string>> {
    const baseHeaders = {
      'X-NW-Message-Id': crypto.randomUUID(),
      'client_id': environment.oidc.clientId
    };
    const jwt = await firstValueFrom(this.oidc.getIdToken());
    const token = await firstValueFrom(this.oidc.getAccessToken());
    // JWT: OIDC ID token — used for AgentCore runtime and the uploads API gateway (both validate the ID token).
    // ACCESS (default): OAuth access token — used for all other API calls.
    if (tokenType === TokenType.JWT) {
      return jwt ? { ...baseHeaders, Authorization: `Bearer ${jwt}` } : baseHeaders;
    }
    return token ? { ...baseHeaders, Authorization: `Bearer ${token}`, 'x-auth-context': 'prod' } : baseHeaders;
  }

  /**
   * The raw OAuth access token, used as the Factory API bearer token forwarded
   * to the agent via the `X-Factory-Api-Token` header. Returns '' when the user
   * has no active access token.
   */
  async getFactoryToken(): Promise<string> {
    return (await firstValueFrom(this.oidc.getAccessToken())) ?? '';
  }
}
